const overrides: Record<string, string> = {
  "email-marketing": createLocalAssetPath("/icons/task-icon-email-send.svg"),
  events: createLocalAssetPath("/icons/task-category-events.svg"),
  "paid-advertising": createLocalAssetPath("/icons/task-category-paid-advertising.svg"),
  strategy: createLocalAssetPath("/icons/task-icon-strategy.svg"),
  "communications-outreach": createLocalAssetPath(
    "/icons/task-category-communication.svg"
  ),
  "generate-image": createLocalAssetPath("/icons/task-image-post.svg"),
  "generate-qr-code": createLocalAssetPath("/icons/qr-code-task.svg"),
  "write-post": createLocalAssetPath("/icons/task-icon-article-simple.svg"),
  "generate-meta-title": createLocalAssetPath("/icons/task-icon-article-simple.svg"),
  "generate-meta-description": createLocalAssetPath(
    "/icons/task-icon-article-simple.svg"
  ),
  "review-webpage": createLocalAssetPath("/icons/task-icon-article-search.svg"),
  "announce-event": createLocalAssetPath("/icons/task-icon-event.svg"),
  "create-event-invitations": createLocalAssetPath("/icons/task-icon-event.svg"),
  "script-video": createLocalAssetPath("/icons/task-icon-video.svg"),
  "produce-video-content": createLocalAssetPath("/icons/task-icon-video.svg"),
  "craft-job-postings": createLocalAssetPath("/icons/task-icon-job-posting.svg"),
  "write-bio": createLocalAssetPath("/icons/task-icon-contact-bio.svg"),
  "create-carousel-posts": createLocalAssetPath("/icons/task-icon-post-stream-horiz.svg"),
  "curate-article-content": createLocalAssetPath("/icons/task-icon-article-simple.svg"),
  "design-story-templates": createLocalAssetPath(
    "/icons/task-icon-instagram-stories.svg"
  ),
  "develop-reels-content-ideas": createLocalAssetPath("/icons/task-icon-reels.svg"),
  "plan-content-calendar": createLocalAssetPath("/icons/task-icon-content-calendar.svg"),
  "craft-highlight-icons": createLocalAssetPath("/icons/task-icon-circle-grid.svg"),
  "generate-hashtag-sets": createLocalAssetPath("/icons/task-icon-hashtag.svg"),
  "plan-ig-live-sessions": createLocalAssetPath("/icons/task-icon-live.svg"),
  "generate-cover-image-ideas": createLocalAssetPath("/icons/task-icon-image-frame.svg"),
  "write-post-captions": createLocalAssetPath("/icons/task-icon-hashtag.svg"),
  "identify-keywords": createLocalAssetPath("/icons/task-icon-article-search.svg"),
};

export function useTaskIcon() {
  const fallback = isDESKTOP
    ? `ma://icons/task-icon-generic.svg`
    : `/icons/task-icon-generic.svg`;

  function getSrc(key: string, iconName?: string) {
    const override = overrides[key];
    return (
      override ||
      (() => {
        if (iconName) {
          return isDESKTOP ? `ma://icons/${iconName}` : `/icons/${iconName}`;
        } else {
          return isDESKTOP
            ? `ma://icons/task-icon-${key}.svg`
            : `/icons/task-icon-${key}.svg`;
        }
      })()
    );
  }

  return { getSrc, fallback };
}
